import $ from "jquery";

function Sponsors(){
    var sponsorsSlide = $('.sponsors').find('.slide');
    // console.log(sponsorsSlide);
    var sponsorsSlideCount = sponsorsSlide.length;
    var sponsorsSlideWidth = (100 / (sponsorsSlideCount + 2));


    if($(window).width() > 600){
        sponsorsSlide.css('width', sponsorsSlideWidth + "%");
    }
    
}

export default Sponsors;